export type AIUsageStats = {
  date: string;
  requests: number;
  tokens: number;
};

const STORAGE_KEY = "excalidraw-ai-usage";

const getTodayDateString = () => {
  const d = new Date();
  return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
};

export const getAIUsage = (): AIUsageStats => {
  try {
    const data = localStorage.getItem(STORAGE_KEY);
    const today = getTodayDateString();
    
    if (data) {
      const parsed = JSON.parse(data) as AIUsageStats;
      if (parsed.date === today) {
        return parsed;
      }
    }
    
    // Reset if it's a new day or no data
    return { date: today, requests: 0, tokens: 0 };
  } catch (e) {
    return { date: getTodayDateString(), requests: 0, tokens: 0 };
  }
};

type Listener = (usage: AIUsageStats) => void;
const listeners = new Set<Listener>();

export const trackAIUsage = (tokensUsed: number) => {
  const current = getAIUsage();
  current.requests += 1;
  current.tokens += tokensUsed;
  
  localStorage.setItem(STORAGE_KEY, JSON.stringify(current));
  
  // Notify listeners
  listeners.forEach(listener => listener(current));
};

export const subscribeToAIUsage = (listener: Listener) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
